import React from 'react';
import { MenuList } from '../MenuList/MenuList';
import { CategorySelector } from '../CategorySelector/CategorySelector';
import './Menu.css'

const linkClicked = {
    borderBottom: '2px solid #8f0303'
}

let isScrolling = false;

export class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.renderMenuLists = this.renderMenuLists.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.state = {
            sticky: false,
            currentList: '',
            pageYOffset: null,
            screenWidth: window.innerWidth,
            isSelectScrolling: false,
        }
        this.handleLink = this.handleLink.bind(this);
        this.handleMobileScroll = this.handleMobileScroll.bind(this);
        this.updateWindow = this.updateWindow.bind(this);
    }

    handleLink(category) {
        this.setState({linkClicked: true});
        let id = category+'-list';
        const yOffset = this.state.screenWidth <=375 ? -145: -210; 
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
        setTimeout(function () {
            isScrolling = false;
        }, 500);
    };
    
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.updateWindow);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("resize", this.updateWindow);
    }

    updateWindow() {
        this.setState({ screenWidth: window.innerWidth });
    }
    handleScroll() {
        this.setState( {pageYOffset: window.pageYOffset});
        if(this.state.screenWidth <= 375 && this.props.mealTime === "Lunch") {
            if(this.state.pageYOffset > 200) {
                if(!this.state.sticky) {
                    this.setState({sticky: true});
                }
            }
            else {
                if(this.state.sticky) {
                    this.setState({sticky: false});
                }
            }
        }
        else {
            if(this.state.pageYOffset > 350 && this.props.mealTime === "Lunch") {
                if(!this.state.sticky) {
                    this.setState({sticky: true});
                }
            }
            else {
                if(this.state.sticky) {
                    this.setState({sticky: false});
                }
            }
        }
        if(!this.state.sticky && document.getElementById("menu-dropdown")) {
            document.getElementById("menu-dropdown").value = 'Menu';
        }
        Object.keys(this.props.menu).forEach(category => {
                let element = document.getElementById(category+'-list');
                var pos = element.getBoundingClientRect().y;
                if(Math.floor(pos) >= 150 && Math.floor(pos) <= 270 && this.state.screenWidth > 375) {
                    this.setState({currentList: category});
                }
                else {
                    if(document.getElementById("menu-dropdown")!==null) {
                        if(Math.floor(pos) >= 140 && Math.floor(pos) <= 160) {
                            console.log(Math.floor(pos));
                            if(!isScrolling) {
                                document.getElementById("menu-dropdown").value = category;
                            }
                        }
                    }
                }
        })  
    }
    handleMobileScroll(e) {
        e.preventDefault();
        let category = e.target.value; 
        isScrolling = true;                       
        this.handleLink(category);
    }
    renderNav() {
        if(this.state.screenWidth <= 375) {
            return (
            <select id = "menu-dropdown" className = "mobile-nav" as="select" onChange = {this.handleMobileScroll} placeholder = "Menu">
                <option value= "Menu" selected disabled hidden> Menu</option>
                {
                    Object.keys(this.props.menu).map(category => {
                        return <option value = {category}>{category}</option>;
                    })
                }
            </select>
            );
        }
        else {
            return (
                <ul>
                {
                    Object.keys(this.props.menu).map(category => {
                        return <li style = {(this.state.currentList === category) ? linkClicked : {}}
                        onClick = {()=>this.handleLink(category)}> <a> {category} </a></li>;
                    })
                }
                </ul>
            );
        }
    }

    renderMenuLists() {
        return (
            <div className = "menu">
                {this.props.mealTime === 'Lunch' && <div className = {`menu-navigator ${this.state.sticky && 'sticky'}`}>
                    <nav>
                        {this.renderNav()}
                    </nav>
                    </div>}           
                <div className = {`menu-content ${this.state.sticky && 'menu-content-sticky'}`}>
                    {
                        Object.keys(this.props.menu).map(category => {
                            return <MenuList showModal = {this.props.showModal} category = {category} items = {this.props.menu[category]}/>;
                        })
                    }
                </div>
                <div className = 'spacer'>

                </div>
            </div>
        ) 
    }
    render() {
        return(
            <div>
                {this.renderMenuLists()}
            </div>
        );
    }

}